(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-calculateur-taille"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Échiquiers du catalogue (code, côté, case en mm)
    var SIZES = [
      { code: '3+', board: '36 × 36 cm', cs: 38 },
      { code: '4', board: '40 × 40 cm', cs: 40 },
      { code: '4+', board: '44 × 44 cm', cs: 45 },
      { code: '5', board: '48 × 48 cm', cs: 50 },
      { code: '5+', board: '52 × 52 cm', cs: 55 },
      { code: '6', board: '54 × 54 cm', cs: 58 }
    ];
    var nf = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
    function fmt(n) { return nf.format(n); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function num(s) {
      var v = parseFloat(String(s || '').replace(',', '.').replace(/[^0-9.]/g, ''));
      return isFinite(v) ? v : NaN;
    }
    function toMm(v, unit) { return unit === 'cm' ? v * 10 : unit === 'in' ? v * 25.4 : v; }

    class MfSizeCalc extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.out = this.querySelector('[data-out]');
        this.val = this.querySelector('[data-value]');
        this.unit = this.querySelector('[data-unit]');
        this.label = this.querySelector('[data-label]');
        this.extra = this.querySelector('[data-extra]');
        this.extraVal = this.querySelector('[data-extra-value]');
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.compute(); });
        this.form.querySelectorAll('input[name="mf-calc-mode"]').forEach((r) => r.addEventListener('change', () => this.sync()));
        this.sync();
        var q = new URLSearchParams(location.search);
        var pre = [['roi', 'roi'], ['base', 'base'], ['case', 'case']].find(function (p) { return q.get(p[0]); });
        if (pre) {
          this.form.querySelector('input[value="' + pre[1] + '"]').checked = true;
          this.sync();
          this.val.value = q.get(pre[0]);
          this.unit.value = 'mm';
          this.compute(true);
        }
      }
      mode() { return this.form.querySelector('input[name="mf-calc-mode"]:checked').value; }
      sync() {
        var m = this.mode();
        this.label.textContent = m === 'roi' ? 'Hauteur du roi' : m === 'base' ? 'Base du roi (diamètre)' : 'Côté d’une case';
        this.val.placeholder = m === 'roi' ? 'Ex. : 95' : m === 'base' ? 'Ex. : 42' : 'Ex. : 55';
        this.extra.hidden = m !== 'case';
        this.out.innerHTML = '';
      }
      error(msg) { this.out.innerHTML = '<p class="mf-calc__error">' + esc(msg) + '</p>'; }
      compute(silent) {
        var m = this.mode();
        var raw = num(this.val.value);
        if (!isFinite(raw) || raw <= 0) { if (!silent) this.error('Saisissez un nombre positif, par exemple 95.'); return; }
        var v = toMm(raw, this.unit.value);
        var limits = { roi: [40, 260, 'La hauteur du roi doit se situer entre 4 et 26 cm.'], base: [15, 80, 'La base du roi doit se situer entre 1,5 et 8 cm.'], case: [25, 80, 'La case doit se situer entre 2,5 et 8 cm.'] }[m];
        if (v < limits[0] || v > limits[1]) { this.error(limits[2]); return; }

        var base = null, baseNote = '', ideal, lo, hi, kingBase = null;
        if (m === 'case') {
          ideal = v; lo = v; hi = v;
          kingBase = { ideal: 0.77 * v, lo: 0.72 * v, hi: 0.82 * v };
        } else {
          base = m === 'roi' ? 0.45 * v : v;
          baseNote = m === 'roi' ? 'estimée à 45 % de la hauteur (la FIDE recommande de 40 à 50 %)' : '';
          ideal = base / 0.765; lo = base / 0.82; hi = base / 0.72;
        }
        var near = SIZES.reduce(function (a, b) { return Math.abs(b.cs - ideal) < Math.abs(a.cs - ideal) ? b : a; });
        var gap = Math.abs(near.cs - ideal);
        var inRange = m === 'case' ? true : near.cs >= lo - 0.05 && near.cs <= hi + 0.05;

        var html = '';
        html += '<div class="mf-calc__reco"><p class="mf-calc__reco-eyebrow">Échiquier recommandé</p>' +
          '<p class="mf-calc__reco-title">N° ' + esc(near.code) + ' · ' + esc(near.board) + '</p>' +
          '<p class="mf-calc__reco-sub">Case de ' + near.cs + ' mm' + (gap > 3 ? ' — le plus proche de notre tableau' : '') + '</p></div>';

        html += '<dl class="mf-calc__list">';
        if (m === 'case') {
          html += '<div><dt>Base du roi idéale (77 %)</dt><dd>' + fmt(kingBase.ideal) + ' mm</dd></div>';
          html += '<div><dt>Plage conseillée (72–82 %)</dt><dd>' + fmt(kingBase.lo) + ' – ' + fmt(kingBase.hi) + ' mm</dd></div>';
        } else {
          html += '<div><dt>Base du roi' + (baseNote ? ' (estimée)' : '') + '</dt><dd>' + fmt(base) + ' mm</dd></div>';
          html += '<div><dt>Case idéale (base ÷ 0,765)</dt><dd>' + fmt(ideal) + ' mm</dd></div>';
          html += '<div><dt>Plage de case (72–82 %)</dt><dd>' + fmt(lo) + ' – ' + fmt(hi) + ' mm</dd></div>';
        }
        html += '<div><dt>Base de pion (50 % de la case)</dt><dd>' + fmt(0.5 * ideal) + ' mm</dd></div>';
        html += '<div><dt>Base de pion (58,6 %, deux pions en diagonale)</dt><dd>' + fmt(0.586 * ideal) + ' mm</dd></div>';
        html += '</dl>';

        if (baseNote) html += '<p class="mf-calc__note">Base du roi ' + esc(baseNote) + '. Si vous connaissez la base exacte, choisissez « la base du roi » : le résultat sera plus précis.</p>';
        if (m !== 'case' && !inRange) html += '<p class="mf-calc__note">Aucune case de notre tableau n’entre exactement dans la plage conseillée ; ' + esc(near.code) + ' est la plus proche.</p>';

        // alertes : la base du roi ne doit jamais atteindre la case
        var warnBase = m === 'case' ? num(this.extraVal.value) : base;
        if (isFinite(warnBase) && warnBase > 0) {
          var caseMm = m === 'case' ? v : near.cs;
          if (warnBase >= caseMm) html += '<p class="mf-calc__warn"><strong>Attention.</strong> La base du roi (' + fmt(warnBase) + ' mm) est supérieure ou égale à la case (' + fmt(caseMm) + ' mm) : les pièces ne tiendraient pas sur leur case. Choisissez un échiquier plus grand.</p>';
        }
        if (m === 'roi' && (v < 85.5 || v > 104.5)) html += '<p class="mf-calc__note">Cette hauteur de roi est hors de la plage de 8,55 à 10,45 cm correspondant aux recommandations de la FIDE (9,5 cm ± 10 %).</p>';
        if (m === 'case' && (v < 50 || v > 60)) html += '<p class="mf-calc__note">La FIDE recommande des cases de 5 à 6 cm pour la compétition.</p>';

        html += '<p class="mf-calc__cta"><a class="mf-link" href="/collections/tous-les-echiquiers">Voir les échiquiers</a></p>';
        this.out.innerHTML = html;
      }
    }
    if (!customElements.get('mf-size-calc')) customElements.define('mf-size-calc', MfSizeCalc);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Sommaire de la FAQ : la rubrique en cours de lecture est mise en évidence
    const toc = document.querySelector('.mf-faq__toc');
    if (!toc || !('IntersectionObserver' in window)) return;
    const links = [...toc.querySelectorAll('a[href^="#faq-"]')];
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id));
        });
      },
      { rootMargin: '-35% 0px -55% 0px' }
    );
    links.forEach((a) => {
      const t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) io.observe(t);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-flip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var c = e.target.closest('.mf-flip__card');
      if (!c) return;
      c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      var s = c.closest('.mf-flip');
      if (s) s.classList.add('is-nudged');
    });
    // le doigt disparaît tout seul quelques secondes après que la section est visible
    document.querySelectorAll('.mf-flip').forEach(function (s) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { s.classList.add('is-nudged'); }, 6000);
      }, { threshold: 0.4 });
      io.observe(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-frise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mf-frise').forEach(function (root) {
      var rail = root.querySelector('.mf-frise__rail');
      var bar = root.querySelector('.mf-frise__prog i');
      var nav = root.querySelector('.mf-frise__nav');
      if (!rail) return;
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var visible = max > 4;
        if (nav) nav.hidden = !visible;
        var seen = rail.clientWidth / rail.scrollWidth;
        var p = max > 0 ? rail.scrollLeft / max : 1;
        bar.style.width = Math.min(100, (seen + (1 - seen) * p) * 100) + '%';
      }
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (nav) nav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dir]');
        if (!b) return;
        var step = rail.querySelector('.mf-frise__step');
        rail.scrollBy({ left: Number(b.dataset.dir) * (step ? step.getBoundingClientRect().width + 24 : 300), behavior: 'smooth' });
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-nuancier"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mf-nuance').forEach(function (root) {
      var chips = root.querySelectorAll('.mf-nuance__chip');
      var panels = root.querySelectorAll('[data-panel]');
      function show(id) {
        chips.forEach(function (c) {
          var on = c.dataset.wood === id;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.id === id) p.removeAttribute('data-off');
          else p.setAttribute('data-off', '');
        });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () { show(c.dataset.wood); });
      });
      if (location.hash && root.querySelector(location.hash.replace(/[^#\w-]/g, ''))) show(location.hash.slice(1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-quiz')) {
    class MfQuiz extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.mf-quiz__form');
        this.steps = [...this.querySelectorAll('.mf-quiz__step')];
        this.result = this.querySelector('.mf-quiz__result');
        this.list = this.querySelector('.mf-quiz__products');
        this.empty = this.querySelector('.mf-quiz__empty');
        this.pool = [...this.querySelectorAll('.mf-quiz__pool .mf-quiz__product')];
        this.history = [];
        this.current = this.steps[0];

        this.form.addEventListener('change', (e) => {
          if (e.target.type !== 'radio') return;
          window.setTimeout(() => this.next(), 260);
        });
        // 19/10 : arrivée depuis la carte quiz d'une collection (?quiz=soi|offrir|deco) : la première réponse est déjà donnée
        const pre = new URLSearchParams(window.location.search).get('quiz');
        if (pre) {
          const r = this.steps[0] && this.steps[0].querySelector(`input[value="quiz-${CSS.escape(pre)}"]`);
          if (r) {
            r.checked = true;
            this.next();
          }
        }
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-back]')) this.back();
          if (e.target.closest('[data-restart]')) this.restart();
        });
      }

      chosen() {
        // réponses des seules questions effectivement posées
        return [...this.history, this.current]
          .map((f) => f && f.querySelector('input:checked'))
          .filter(Boolean)
          .map((i) => i.value);
      }

      findStep(n) {
        const answers = this.chosen();
        return this.steps.find(
          (f) => Number(f.dataset.step) === n && (!f.dataset.condition || answers.includes(f.dataset.condition))
        );
      }

      show(fieldset) {
        this.current = fieldset;
        this.steps.forEach((f) => (f.hidden = f !== fieldset));
        this.result.hidden = true;
        this.form.hidden = false;
        const legend = fieldset.querySelector('legend');
        if (legend) legend.focus({ preventScroll: true });
      }

      next() {
        const nextStep = this.findStep(Number(this.current.dataset.step) + 1);
        if (nextStep) {
          this.history.push(this.current);
          nextStep.querySelectorAll('input').forEach((i) => (i.checked = false));
          this.show(nextStep);
        } else {
          this.finish();
        }
      }

      back() {
        const prev = this.history.pop();
        if (prev) this.show(prev);
      }

      finish() {
        const chosen = this.chosen();
        const scored = this.pool
          .map((li, order) => {
            const tags = (li.dataset.tags || '').split(' ');
            return { li, order, score: chosen.filter((c) => tags.includes(c)).length };
          })
          .filter((p) => p.score > 0)
          .sort((a, b) => b.score - a.score || a.order - b.order)
          .slice(0, 3);

        this.list.replaceChildren(
          ...scored.map((p) => {
            const clone = p.li.cloneNode(true);
            // images de la réserve cachée : on force leur chargement une fois affichées
            clone.querySelectorAll('img').forEach((img) => {
              img.loading = 'eager';
              if (img.srcset) img.srcset = img.srcset;
            });
            return clone;
          })
        );
        this.empty.hidden = scored.length > 0;
        this.form.hidden = true;
        this.result.hidden = false;
        this.result.focus({ preventScroll: true });
        this.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      restart() {
        this.form.reset();
        this.history = [];
        this.show(this.steps[0]);
      }
    }
    customElements.define('mf-quiz', MfQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-recently-viewed"]) return;
  try {
    
  if (!customElements.get('mf-recently-viewed')) {
    customElements.define(
      'mf-recently-viewed',
      class extends HTMLElement {
        async connectedCallback() {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const limit = Number(this.dataset.limit) || 4;
          const current = this.dataset.current;
          const valid = (h) => h && h !== current && /^[a-z0-9-]+$/.test(h);

          let recent = [];
          try {
            recent = JSON.parse(localStorage.getItem('mf-recent') || '[]');
          } catch (e) {}
          recent = recent.filter(valid).slice(0, limit);

          // modèles de même rang, choisis côté Liquid (snippets/mf-same-tier)
          const reco = (this.dataset.reco || '').split(',').filter(valid).slice(0, limit);

          // la carte des collections, rendue par templates/product.mf-card.liquid
          const load = (handles) =>
            Promise.all(
              handles.map((h) =>
                fetch(`${root}products/${h}?view=mf-card`)
                  .then((r) => (r.ok ? r.text() : null))
                  .catch(() => null)
              )
            ).then((list) => list.filter((html) => html && html.includes('mf-rail__item')));
          const [recoItems, recentItems] = await Promise.all([load(reco), load(recent)]);

          const shown = [];
          if (this.fill('reco', recoItems)) shown.push('reco');
          if (this.fill('recent', recentItems)) shown.push('recent');
          if (!shown.length) return;

          const tabs = [...this.querySelectorAll('[data-tab]')];
          tabs.forEach((t) => (t.hidden = !shown.includes(t.dataset.tab)));
          this.classList.toggle('is-single', shown.length === 1);
          this.select(shown[0]);
          tabs.forEach((t) => {
            t.addEventListener('click', () => this.select(t.dataset.tab));
            t.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              const other = tabs.find((x) => x !== t && !x.hidden);
              if (other) {
                this.select(other.dataset.tab);
                other.focus();
              }
            });
          });
          this.closest('section').hidden = false;
        }

        select(name) {
          this.querySelectorAll('[data-tab]').forEach((t) => {
            const on = t.dataset.tab === name;
            t.setAttribute('aria-selected', on);
            t.tabIndex = on ? 0 : -1;
          });
          this.querySelectorAll('[data-panel]').forEach((p) => (p.hidden = p.dataset.panel !== name));
        }

        fill(name, items) {
          if (!items.length) return false;
          // même rangée et mêmes cartes que « Dans la même collection »
          const track = document.createElement('div');
          track.className = 'mf-rail__track';
          const ul = document.createElement('ul');
          ul.className = 'mf-rail__list';
          ul.setAttribute('role', 'list');
          ul.innerHTML = items.join('');
          track.append(ul);
          this.querySelector(`[data-panel="${name}"]`).append(track);
          if (ul.children.length > 1) this.progress(ul, track);
          return true;
        }

        // 29/10 (retour cliente : « on ne sait pas qu'on peut tourner pour en voir d'autres ») :
        // téléphone seulement, la barre qui avance et le compteur de la galerie photo (assets/mf-product.css)
        progress(ul, track) {
          const n = ul.children.length;
          const pad = (i) => String(i).padStart(2, '0');
          const bar = document.createElement('div');
          bar.className = 'mf-gallery-dots mf-gallery-dots--compact mf-recent__progress';
          bar.setAttribute('aria-hidden', 'true');
          bar.innerHTML =
            '<span class="mf-gallery-dots__track"><span class="mf-gallery-dots__bar"></span></span>' +
            '<span class="mf-gallery-dots__count"><b>01</b> / ' + pad(n) + '</span>';
          track.after(bar);
          const count = bar.querySelector('b');
          let ticking = false;
          const update = () => {
            ticking = false;
            const max = ul.scrollWidth - ul.clientWidth;
            bar.style.setProperty('--mf-gal-p', max > 0 ? Math.min(Math.max(ul.scrollLeft / max, 0), 1) : 0);
            const mid = ul.getBoundingClientRect().left + ul.clientWidth / 2;
            let best = 0;
            let dist = Infinity;
            [...ul.children].forEach((li, i) => {
              const r = li.getBoundingClientRect();
              const d = Math.abs(r.left + r.width / 2 - mid);
              if (d < dist) {
                dist = d;
                best = i;
              }
            });
            count.textContent = pad(best + 1);
          };
          ul.addEventListener(
            'scroll',
            () => {
              if (!ticking) {
                ticking = true;
                requestAnimationFrame(update);
              }
            },
            { passive: true }
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
